import { Location } from 'history'

import Layout from '@/app/component/layout/page'
import { PAGE } from '@/app/definitions'
import { AuthGuard, AuthHeader } from '@/app/module/auth'
import RequestResetPasswordForm from '@/app/module/auth/component/request-reset-password'
import ResetPasswordForm from '@/app/module/auth/component/reset-password'
import Notifications from '@/app/module/notifications'
import { MatchProps } from '@/app/types'

type Props = {
  name: string
  location: Location
  match: MatchProps
}

export default function ResetPasswordPage(props: Props) {
  const { name, match } = props
  const params = new URLSearchParams(props.location.search)
  return (
    <AuthGuard url={match.url} path={name === PAGE.ACCOUNT.RESET_PASSWORD && !params.has('id') ? '' : match.path}>
      <Layout title="Reset Password - engageSPARK">
        <AuthHeader currentPage={name} />
        {name === PAGE.ACCOUNT.REQUEST_RESET_PASSWORD ? <RequestResetPasswordForm /> : <ResetPasswordForm />}
        <Notifications />
      </Layout>
    </AuthGuard>
  )
}
